function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.502 5a1.5 1.5 0 110 3H11.5a1.5 1.5 0 110-3h.002zm2.5 14H10a1 1 0 010-2h1v-5h-1a1 1 0 010-2h2.003a1 1 0 011 1v6h1a1 1 0 010 2zm6.48-15.486A11.923 11.923 0 0011.997 0C8.789 0 5.775 1.248 3.509 3.514c-4.679 4.68-4.679 12.292 0 16.972A11.927 11.927 0 0011.996 24c3.207 0 6.22-1.249 8.487-3.514A11.92 11.92 0 0024 12c0-3.206-1.25-6.22-3.517-8.486z"
});

var SvgIconInfoFilled = function SvgIconInfoFilled(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgIconInfoFilled;